/**
 * P1-60 — persist last typed discount code across sign-in so PhoneFirst can auto re-apply once.
 */
const DRAFT_PREFIX = 'rpapp.promoCodeDraft.v1:';

export function promoCodeDraftStorageKey(
  tenantCode: string,
  checkoutSessionPublicId: string,
): string {
  return `${DRAFT_PREFIX}${tenantCode}:${checkoutSessionPublicId}`;
}

export function savePromoCodeDraft(input: {
  readonly tenantCode: string;
  readonly checkoutSessionPublicId: string;
  readonly code: string;
}): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  const sessionId = input.checkoutSessionPublicId.trim();
  const code = input.code.trim();
  if (sessionId.length === 0 || code.length === 0) {
    return;
  }
  try {
    sessionStorage.setItem(
      promoCodeDraftStorageKey(input.tenantCode, sessionId),
      code,
    );
  } catch {
    // Best-effort — private mode / quota must not block sign-in navigation.
  }
}

export function consumePromoCodeDraft(input: {
  readonly tenantCode: string;
  readonly checkoutSessionPublicId: string;
}): string | null {
  if (typeof sessionStorage === 'undefined') {
    return null;
  }
  const sessionId = input.checkoutSessionPublicId.trim();
  if (sessionId.length === 0) {
    return null;
  }
  const key = promoCodeDraftStorageKey(input.tenantCode, sessionId);
  try {
    const value = sessionStorage.getItem(key);
    sessionStorage.removeItem(key);
    if (value == null) {
      return null;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  } catch {
    return null;
  }
}
